// Hero background photo, served through Cloudinary transformations:
// f_auto picks the best format the browser supports (AVIF/WebP), q_auto
// compresses, and w_ resizes so phones don't download a desktop-sized file.
const BASE = "https://res.cloudinary.com/ddwxuh0d0/image/upload";
const PUBLIC_ID = "v1765650915/benefits-bg_oaqkvg.webp";

export const heroImageUrl = (width) => `${BASE}/f_auto,q_auto,w_${width}/${PUBLIC_ID}`;

export const HERO_SRC = heroImageUrl(1600);
export const HERO_SRCSET = [640, 1024, 1600, 2400].map((w) => `${heroImageUrl(w)} ${w}w`).join(", ");
export const HERO_SIZES = "100vw";
